module.exports = __webpack_public_path__ + "media/images/logo-inverse-f699a293.svg";